<button class="btn btn-primary" (click)="createNewEvent()">
  <fa-icon icon="plus" size="lg"></fa-icon>
  Publier un événement
</button>

<app-dynamic-modal-form
  [title]="event?.id ? 'Modification d\'un événement' : 'Publication d\'un événement'"
  [object]="event"
  [actions]="[{label: 'Publier', class: 'btn-primary', icon: 'plus'}]"
  size="lg"
  [generator]="eventFormGeneratorService"
  [doOnChange]="onChangedForm"
  (onSubmit)="save($event)">
</app-dynamic-modal-form>
